// Dependencies
var _ = require('underscore');
var Backbone = require('backbone');
var Radio = require('backbone.radio');

// App
var DeferEntity = require('app/utils/defer-entity');
var ChoicesModel = require('app/common/entities/constants');
var EntitiesAPI = require('app/utils/entities').EntitiesAPI;

// Channels
var channel = Radio.channel('global');

var Constants = Backbone.Collection.extend({
    model: ChoicesModel,
    url: '/public/constants.json',
});

var ConstantsGroups = Backbone.Collection.extend({
    url: '/public/constants/groups.json',
});

var constants = new DeferEntity(Constants);
var constantsGroups = new DeferEntity(ConstantsGroups);

var ConstantsAPI = EntitiesAPI.extend({
    radioPrefix: false,
    channel: channel,
    replyConstants: function(options) {
        options = options || {};
        _.defaults(options, { returnInstance: false });
        return constants.defer(options);
    },
    replyConstantsGroups: function(options) {
        options = options || {};
        _.defaults(options, { returnInstance: false });
        return constantsGroups.defer(options);
    },
    replyConstantsPick: function(pick, options) {
        if (!pick) {
            return undefined;
        }

        options = options || {};
        var instance = constants.defer({ returnInstance: true });
        var constant = instance.findWhere({ name: pick });

        if (options.label || options.val) {
            var requested = options.label ? 'val' : 'label';
            return constant
                .get('choices')
                .findWhere(options)
                .get(requested);
        }

        return constant;
    },
    replyConstantsGroupsPick: function(pick) {
        if (!pick) {
            return undefined;
        }

        var instance = constantsGroups.defer({ returnInstance: true });
        var group = instance.findWhere({ name: pick });

        return group.get('constants');
    },
});

module.exports = {
    Constants: Constants,
    ConstantsGroups: ConstantsGroups,
    API: ConstantsAPI,
};
